import { render } from "./EditTransaction.vue?vue&type=template&id=200c9f9a&scoped=true"
import script from "./EditTransaction.vue?vue&type=script&lang=js"
export * from "./EditTransaction.vue?vue&type=script&lang=js"

import "./EditTransaction.vue?vue&type=style&index=0&id=200c9f9a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200c9f9a"]])

export default __exports__